<template>
  <div class="dota">
    <!-- <div class="hint flex flex-ac">
      <div class="btn-w-r-bg" @click="goUrl('/upgrade')">
        <div class="btn-c-r">前往升级</div>
      </div>
      <div class="btn-w-r-bg btn-danger" @click="coniAll()">
        <div class="btn-c-r">全部收回</div>
      </div>
      <div class="btn-w-r-bg btn-blue" @click="$refs['RulePopup'].toggle('ReceivingAssistance')">
        <div class="btn-c-r">收货帮助</div>
      </div>
    </div> -->
    <!-- <div class="dota-sel">
      <div></div>
      <div class="sel-right">
        <div class="right-one">
          <span class="span1" @click="selAll()" v-if="checkedPrice>0">
            <span style="color:#e9b10e;padding:0">({{checkedPrice}})</span>选择当前页</span>
          <span class="span1" @click="selAll()" v-else>选择当前页</span>
          <span class="span1" @click="offAll()">取消选择</span>
          <el-button class="span2" size="small" @click="coniAll()" :disabled="loading">
            <i v-if="loading" class="el-icon-loading"></i>取回</el-button>
        </div>
      </div>
    </div> -->
    <div class="bill-top">
      <div class="scRadio">
        <div class="scRadio-item" :class="{'scRadio-item-a':searchForm.status==1}" @click="getTab(1)">我的库存</div>
        <div class="scRadio-item" :class="{'scRadio-item-a':searchForm.status==2}" @click="getTab(2)">待发货</div>
        <div class="scRadio-item" :class="{'scRadio-item-a':searchForm.status==5}" @click="getTab(5)">发货中</div>
        <div class="scRadio-item" :class="{'scRadio-item-a':searchForm.status==3}" @click="getTab(3)">已取回</div>
      </div>
      <div class="sel-form-select">
        <el-select v-model="searchForm.sort" placeholder="请选择" @change="handleCommand">
          <el-option label="按获取时间排序" :value="1"></el-option>
          <el-option label="按价格升序" :value="2"></el-option>
          <el-option label="按价格降序" :value="3"></el-option>
        </el-select>
      </div>
      <div v-if="searchForm.status==1" class="right-one">
        <div class="btns flex flex-ac">
          <template v-if="isChooie">
            <div v-if="list.length == selectIds.length" class="btn btn-warning flex flex-jc flex-ac" @click="selectAll(false)">
              <span>取消全选</span>
            </div>
            <div v-else class="btn btn-warning flex flex-jc flex-ac" @click="selectAll(true)">
              <span>全选</span>
            </div>
            <div class="btn btn-danger flex flex-jc flex-ac" @click="getPull">
              <span>确认分解可得{{ checkedPrice }}</span>
              <img src="@/assets/images/masonry.png" class="masonry-img" />
            </div>
            <div class="btn flex flex-jc flex-ac" @click="cancleSubmit">
              <span>取消分解</span>
            </div>
          </template>
          <div v-else class="btn btn-warning flex flex-jc flex-ac" @click="isChooie=true">
            <span>批量分解</span>
          </div>
        </div>
      </div>
    </div>
    <div class="dota-warp">
      <empty v-if="list.length===0" :padding="30" description="暂无饰品"></empty>
      <div v-loading="loading" class="dota-list">
        <div class="revisionSkin">
          <ul>
            <li v-for="item in list" :key="item.id" class="skin-li" :class="parseColor(item)" @click="selectItem(item)">
              <div class="li-div">
                <div class="skin-item-content">
                  <span class="ico">{{ item.exteriorName }}</span>
                  <div class="bei">
                    <img :src="item.img" class="img_active" />
                  </div>
                  <div class="name name-line2 p-2">{{ item.name }}</div>
                  <div class="money-warp">
                    <img src="@/assets/images/money.png" class="money-img" />
                    <span>{{ item.price }}</span>
                  </div>
                  <div class="color-line" :style="'background-color:'+parseColor(item,'','color')"></div>
                  <!-- <div class="year">2022</div> -->
                </div>
                <div v-if="isChooie" class="choose-icon">
                  <i v-if="selectIds.indexOf(item.id)==-1" class="iconfont icon-weixuanzhong"></i>
                  <i v-else class="iconfont icon-choose"></i>
                </div>
                <div v-if="isChooie" class="skin-item-btn-show2 flex flex-jc flex-ac">
                  <div style="color: red;font-size: 14px;">分解得{{ item.price }}<img src="@/assets/images/masonry.png" class="masonry-img" /></div>
                </div>
                <div v-if="searchForm.status==1&&!isChooie" class="skin-item-btn-show">
                  <div class="div flex flex-jc flex-ac">
                    <div class="btn-w-r-bg" @click="handleUpgrade(item)">
                      <div class="btn-c-r">升级</div>
                    </div>
                    <div class="btn-w-r-bg btn-blue" @click.stop="getExchange(item)">
                      <div class="btn-c-r">取回</div>
                    </div>
                  </div>

                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="csgo-page">
          <el-pagination background layout="prev, pager, next" :current-page.sync="searchForm.page" :total="searchForm.totalSize" :page-size="searchForm.limit" @current-change="currentChange">
          </el-pagination>
        </div>
      </div>
    </div>
    <RulePopup ref="RulePopup" />
    <confirmation-popup ref="confirmation-popup" @onSubmit="onSubmit" />
  </div>
</template>

<script>
import empty from "@/g-components/empty.vue";
import RulePopup from "@/components/rule-popup.vue"
import { parseColor } from "@/assets/js/util.js";
import ConfirmationPopup from "@/components/confirmation-popup.vue"

export default {
  components: { RulePopup, empty, ConfirmationPopup },
  data() {
    return {
      parseColor,
      loading: false,
      searchForm: {
        sort: 1,
        sort_field: 'ps.update_time',
        sort_value: 'desc',
        status: 1,
        page: 1,
        totalSize: 0,
        limit: 20,
      },
      list: [],
      selectList: [],
      selectIds: [],
      checkedPrice: 0,
      isChooie: false,
      activeName: "money"
    };
  },
  mounted() {
    this.getList();
    this.randomString();
  },
  methods: {
    getTab(e) {
      if (this.searchForm.status == e) return
      this.isChooie = false
      this.selectList = []
      this.selectIds = []
      this.checkedPrice = 0
      this.searchForm.status = e
      this.searchForm.page = 1
      this.getList()
    },
    cancleSubmit() {
      this.isChooie = false
      this.selectList = []
      this.selectIds = []
      this.checkedPrice = 0
    },
    //分页
    currentChange(val) {
      this.searchForm.page = val
      this.getList()
    },
    handleCommand(e) {
      if (e == 1) {
        this.searchForm.sort_field = 'ps.update_time'
        this.searchForm.sort_value = 'desc'
      } else if (e == 2) {
        this.searchForm.sort_field = 'ps.price'
        this.searchForm.sort_value = 'asc'
      } else {
        this.searchForm.sort_field = 'ps.price'
        this.searchForm.sort_value = 'desc'
      }
      // sort_field nickname
      // sort_field nickname
      this.searchForm.page = 1
      this.getList();
    },
    //背包数据
    getList() {
      this.$doGet('/api/member.SkinBackpack/list', this.searchForm).then((res) => {
        this.searchForm.totalSize = res.data.count
        this.list = res.data.list
        this.selectList = []
        this.selectIds = []
        for (let i = 0; i < this.list.length; i++) {
          this.list[i].state = false
          this.list[i].loading = false
        }
      }).catch(() => { })
    },
    //取回
    onSubmit(data) {
      console.log(data)
    },
    getExchange(item) {
      const that = this
      this.$confirm('确定取回该饰品？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (item.state) {
          this.$message({
            message: "正在取回中，稍后重试",
            type: "warning",
          });
          return;
        }
        item.state = true
        item.loading = true
        this.$forceUpdate();
        this.$doPost("/api/member.SkinBackpack/skinToSteam", {
          player_skins_ids: [item.id]
        }).then((res) => {
          this.searchForm.page = 1
          this.getList()
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          });
        }).catch((err) => {
          this.loading = false;
          const that = this
          // 这个是交易信息出现的问题等之后处理
          if (err.message.indexOf('交易地址') > 0) {
            setTimeout(function () {
              that.$store.commit('setPersonalOpen', 'tradeUrl')
            }, 2000)
          }
        })
      }).catch(() => {
      })
    },
    // 选中操作
    selectAll(method) {
      if (this.searchForm.status == 1 && this.isChooie) {
        this.list.forEach((item) => {
          let index = this.selectIds.indexOf(item.id)
          if (index == -1) {
            if (method == true) {
              this.selectList.push(item)
              this.selectIds.push(item.id)
            }
          } else {
            if (method == false) {
              this.selectIds.splice(index, 1)
              this.selectList.splice(index, 1)
            }
          }
          this.checkedPrice = 0
          this.selectList.map(s => {
            this.checkedPrice = s.price * 1 + this.checkedPrice
          })
        })
        this.checkedPrice = this.checkedPrice.toFixed(2)
        this.$forceUpdate()
      }
    },
    // 选中操作
    selectItem(item) {
      if (this.searchForm.status == 1 && this.isChooie) {
        console.log(item)
        let index = this.selectIds.indexOf(item.id)
        if (index == -1) {
          this.selectList.push(item)
          this.selectIds.push(item.id)
        } else {
          this.selectIds.splice(index, 1)
          this.selectList.splice(index, 1)
        }
        this.checkedPrice = 0
        this.selectList.map(s => {
          this.checkedPrice = s.price * 1 + this.checkedPrice
        })
        this.checkedPrice = this.checkedPrice.toFixed(2)
        this.$forceUpdate()
      }
    },
    //点击回收
    getPull() {
      if (this.selectIds.length === 0) {
        this.$message({
          message: "请至少选中一个饰品",
          type: "warning",
        });
        return;
      }
      this.$doPost("/api/member.SkinBackpack/exchangeToMoney", {
        player_skins_ids: this.selectIds
      }).then((res) => {
        console.log(res)
        this.$store.commit("getAboutMon", res.data)
        this.searchForm.page = 1
        this.selectList = []
        this.selectIds = []
        this.checkedPrice = 0
        this.isChooie = false
        this.getList()
        this.$message({
          showClose: true,
          message: res.msg,
          type: "success",
        });
      }).catch((err) => { })
      // this.$confirm('确定分解选中的饰品？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //
      // }).catch(() => { })
    },
    randomString(e) {
      e = e || 32;
      var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
        a = t.length,
        n = "";
      for (var i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
      this.random = n;
    },
    handleUpgrade(item) {
      localStorage.setItem('upgradeData', JSON.stringify(item))
      this.$router.push({
        path: '/upgrade?id=' + item.id,
      });
    },
    goUrl(url) {
      this.$router.push({
        path: url,
      });
    }
  },
};
</script>

<style lang="less" scoped>
.bill-top {
  padding-top: 15px;
  text-align: center;
  position: relative;
}
.dota {
  .hint {
    padding: 36px 36px 0;
    .btn-w-r-bg {
      width: 180px;
      margin-right: 28px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .dota-warp {
    .dota-list {
      padding: 26px 26px 0;
      .revisionSkin ul li {
        padding: 10px;
      }
    }
  }
}
.sel-form-select {
  position: absolute;
  left: 36px;
  top: 15px;
  width: 145px;
  ::v-deep .el-input__inner {
    height: 36px;
    line-height: 36px;
    color: #6a6a6a;
    border: 1px solid #6a6a6a;
    background-color: transparent;
  }
  ::v-deep .el-input__icon {
    line-height: 36px;
  }
}
.right-one {
  position: absolute;
  right: 36px;
  top: 15px;
}
.btns {
  .btn {
    padding: 0 12px;
    line-height: 30px;
    background: #346162;
    border-radius: 4px;
    border: 1px solid #00f7ff;
    font-size: 14px;
    color: #00f7ff;
    cursor: pointer;
    i {
      margin-right: 8px;
    }
    &.btn-warning {
      background: #554b29;
      border: 1px solid #ffc400;
      color: #ffc400;
      margin-right: 16px;
    }
    &.btn-danger {
      background: #FF6060;
      border: 1px solid #FF6060;
      color: #ffffff;
      margin-right: 16px;
    }
  }
}
</style>
